import { TRIAL_DAYS } from '../constants';
import { UserProfile } from '../types';

const DAY_MS = 1000 * 60 * 60 * 24;

export interface PlanStatus {
  plan: 'FREE' | 'GOLD';
  isActive: boolean;
  remainingDays: number;
  expiresAt: Date;
}

function getRemainingDays(expiresAt: Date, now = new Date()): number {
  const diff = expiresAt.getTime() - now.getTime();
  return Math.max(0, Math.ceil(diff / DAY_MS));
}

export function getFreePlanStatus(profile: UserProfile, now = new Date()): PlanStatus {
  const start = new Date(profile.firstLogin);
  const expiresAt = new Date(start);
  expiresAt.setDate(expiresAt.getDate() + TRIAL_DAYS);

  // Free trial removed: the FREE plan is always inactive immediately, for
  // both new and already-existing users, regardless of TRIAL_DAYS/firstLogin.
  return {
    plan: 'FREE',
    isActive: false,
    remainingDays: 0,
    expiresAt
  };
}

export function getGoldPlanStatus(profile: UserProfile, now = new Date()): PlanStatus {
  const expiresAt = profile.subscription.expiresAt
    ? new Date(profile.subscription.expiresAt)
    : new Date(0);

  const remainingDays = getRemainingDays(expiresAt, now);
  return {
    plan: 'GOLD',
    isActive: remainingDays > 0,
    remainingDays,
    expiresAt
  };
}

export function getCurrentPlanStatus(profile: UserProfile, now = new Date()): PlanStatus {
  if (profile.subscription.plan === 'GOLD') {
    return getGoldPlanStatus(profile, now);
  }

  return getFreePlanStatus(profile, now);
}
